import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Helmet } from 'react-helmet';
import Casestudyback from '../../../../Component/Casestudyback'
import Banner from "../../../../asset/images/insight/case_studies/banner-achieving-100-audit-compliance.webp"
import { Link } from 'react-router-dom';

export default function AchievingAuditCompliance() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Helmet><meta charset="UTF-8" />
                <meta charset="UTF-8" />
                <title>Achieve 100% Audit Compliance with Bordereaux Correction</title>
                <meta name="description" content="Discover how Decimal Point Analytics helped a global insurer fix Bordereaux data issues and achieve 100% KPMG audit compliance with full transparency." />
                <link rel="canonical" href="/case-study/kpmg-audit-compliance-bordereaux-data-correction" />
            </Helmet>

            <Box id="case-studies" className='section sec_bg new_cs' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={3} alignItems="top" justifyContent='center'>
                        <Grid item lg={10} md={10} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h3' className='subhead skblue al_center'>
                                    Success Stories
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Achieving 100% Audit Compliance <span className='lower'>by</span> Fixing Data Errors <span className='lower'>in</span> Bordereaux Reporting
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    <Box>
                        <img loading="lazy" src={Banner} className='w100' alt='Banner' />
                    </Box>

                    <Box className='whitebx'>

                        <Box>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Client Overview
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                A prominent global insurance provider faced increasing audit risks due to discrepancies in their Bordereaux reporting process, which drew scrutiny during an external audit conducted by KPMG.
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Problem Statement
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                The client’s Bordereaux reporting process revealed several compliance vulnerabilities:
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Inconsistencies in premium and claims data raised concerns about accuracy.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            The process was flagged during a critical external audit by KPMG, increasing the urgency to resolve the issues.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            These inaccuracies posed a serious risk of audit failure, threatening the client’s regulatory standing and reputation.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            The lack of a transparent data workflow made it difficult to explain discrepancies to auditors.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Solution Provided
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                Decimal Point Analytics deployed its Compliance and Risk Management Services to bring transparency, structure, and control to the audit process:
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Conducted an in-depth review of Bordereaux data to ensure accuracy and audit readiness.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Identified and corrected discrepancies in premium and claims data, backed by complete documentation.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Implemented a transparent, step-by-step data workflow tailored for audit clarity.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Collaborated closely with KPMG auditors to resolve all concerns promptly and effectively.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Outcome
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst'>
                                <ul>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            The client completed the audit with zero significant findings, achieving full compliance.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Internal confidence in the accuracy and reliability of Bordereaux reporting improved significantly.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Audit preparation time was greatly reduced, streamlining compliance efforts.
                                        </Typography>
                                    </li>
                                    <li>
                                        <Typography variant='h6' className='black jst'>
                                            Transparency and traceability reinforced trust with auditors and regulators.
                                        </Typography>
                                    </li>
                                </ul>
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h2' className='blue h2h4' gutterBottom>
                                Key Takeaway
                            </Typography>
                        </Box>

                        <Box mt={2}>
                            <Typography variant='h6' className='black jst mb0'>
                                Clear documentation, proactive audit collaboration, and structured data workflows are essential for reducing compliance risk and ensuring audit success in the insurance sector.
                            </Typography>

                            <Typography variant='h6' className='black jst mb0'>
                                Worried about data inconsistencies impacting your next audit?
                            </Typography>

                            <Typography variant='h6' className='black jst'>
                                <Link to="/contact-us#contact_form" className='link'>Connect with us</Link> to discover how our audit-focused solutions can enhance transparency, speed, and regulatory confidence.
                            </Typography>
                        </Box>
                    </Box>

                    <Casestudyback />

                </Container>
            </Box>
        </>
    );
}